import { z } from "zod";
export const BrandedEmailReadinessV1Schema = z
    .object({
    schemaVersion: z.literal("branded-email-readiness.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalBrandedEmailReadiness(recordedAt) {
    return BrandedEmailReadinessV1Schema.parse({
        schemaVersion: "branded-email-readiness.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=branded-email-readiness.js.map